import { render, staticRenderFns } from "./pedidos.vue?vue&type=template&id=bbb6441c"
import script from "./pedidos.vue?vue&type=script&lang=js"
export * from "./pedidos.vue?vue&type=script&lang=js"
import style0 from "./pedidos.vue?vue&type=style&index=0&id=bbb6441c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports